module.exports = __webpack_public_path__ + "img/varnish.02cbb3d8.png";